// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2l1E3","content":"LayoutSettings_content__3Rdj9"};